import styled from '@emotion/styled'

export const AttachmentInfoContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})

export const Cont = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',

  '.title': {
    fontWeight: 'bold',
    marginTop: '1rem'
  }
}))

export const FileCont = styled.div((props) => ({
  display: 'flex',
  marginTop: '0.5rem',

  '>div:first-child': {
    flex: 1
  },
  '>div:last-child': {
    flex: 4
  },

  '.titleFile': {
    fontWeight: 'normal',
    display: 'flex',
    justifyContent: 'flex-end'
  },

  '.fileItem': {
    fontWeight: 'normal',
    display: 'flex',
    flexDirection: 'column',
    'button': {
      marginTop: '0.1rem'
    }
  },

  '.fileName': {
    display: 'flex',
    justifyContent: 'flex-start',
    wordBreak: 'break-all',
  },

  '.noFile': {
    fontStyle: 'italic',
    marginLeft: '1rem'
  },

  '.button': {
    marginLeft: '1rem'
  }
}))

export const SContDetail = styled.div(props => ({
  display: 'flex',
  marginTop: props.sub ? '0' : '1rem',

  '&>div:first-child': {
    marginLeft: 0,
    flex: 1
  },

  '>div:first-child .toleft': {
    marginLeft: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },

  '&>div': {
    marginLeft: '1rem',
    flex: 1
  }
}))

export const AttachmentGroup = styled.div({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  marginTop: '15px',

  '&:first-child': {
    marginTop: '0px',
  },

  'div.attachmentLabel': {
    display: 'flex',
    fontWeight: 'bold',
    minWidth: '100px',
    height: '40px',
    alignItems: 'center',
  },

  'div.attachmentBy': {
    display: 'flex',
    minWidth: '150px',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginRight: '5px',

    span: {
      fontWeight: 'bold',
    },
  },
})

export const AttachmentContent = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',

  'div:first-child>div': {
    marginTop: '0px',
  },

  'div>div': {
    marginTop: '5px',
  }
})